module.exports = __webpack_public_path__ + "img/vertical_3_5_8019.6b2bdf01.png";